"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedErrorCodes = void 0;
var SharedErrorCodes;
(function (SharedErrorCodes) {
    SharedErrorCodes["IMMUTABLE_FIELD"] = "IMMUTABLE_FIELD";
    SharedErrorCodes["INVALID_INPUT"] = "INVALID_INPUT";
    SharedErrorCodes["MISSING_MANDATORY_FIELD"] = "MISSING_MANDATORY_FIELD";
    SharedErrorCodes["UNAUTHORIZED"] = "UNAUTHORIZED";
    SharedErrorCodes["UNEXPECTED_CODE_PATH"] = "UNEXPECTED_CODE_PATH";
    SharedErrorCodes["UNEXPECTED_FIELD"] = "UNEXPECTED_FIELD";
    SharedErrorCodes["UNKNOWN_ERR"] = "UNKNOWN_ERR";
    SharedErrorCodes["VALIDATION_ERR"] = "VALIDATION_ERR";
})(SharedErrorCodes = exports.SharedErrorCodes || (exports.SharedErrorCodes = {}));
//# sourceMappingURL=SharedErrorCodes.js.map